
<mat-dialog-content style = "background-color: #0E0D35 !important;">
  <div class="testQuestion">
    <h3 class="questionText" style = "font-size: 2.3vh; font-weight: normal;">
      {{labels.lblControlQuestion.toUpperCase()}}
    </h3>
    <h3 class="questionText" style = "font-size: 3.7vh;">
      {{currentQuestion.text}}
    </h3>
    @if (currentQuestion.type == 2) {
      <h4><span style="color:rgb(241,106,100);">*{{labels.lblSeveralCorrectAnswers}}</span></h4>
    }
    @for (answer of currentQuestion.answers; track answer) {
      <div class="answer" style = "display: inline-flex !important;"
        [class.answerSelected]='answer.selected'>
        <mat-checkbox [value]="answer._id" class="checkBox mat-checkbox-stretch" style = "width: 100%;" [(ngModel)]="answer.selected"
          (change)="onSelect(currentQuestion, answer);">
          <span class="test" style = "white-space: break-spaces;">
          {{answer.textAns1}}</span>
        </mat-checkbox>
      </div>
    }

    @if (isClicked) {
      <div style = "text-align: right;">
        <button mat-raised-button class="button"
          (click)="submit(currentQuestion)">
          {{labels.lblSubmit}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: #0E0D35;">arrow_forward</mat-icon></button></div>
        }
      </div>
    </mat-dialog-content>
